import { ListIcon } from "./styles";

const ControlEars = () => (
  <ListIcon>
    <span></span>
    <span></span>
  </ListIcon>
);

export default ControlEars;
